import React, { Component } from 'react';
import Donut from 'react-minimal-pie-chart';
import _ from 'lodash';

import { withContext } from '../../App';
import { dataExtractor } from './helpers';

import './styles.scss';

class Chart extends Component {
  constructor(props) {
    super(props);

    this.state = { data: [] };
  }

  componentDidMount() {
    const { topic, context: { topicData, statData }, answer } = this.props;

    this.setState({
      data: dataExtractor(statData, topic, topicData[topic].options.map(option => option.title), answer)
    });
  }

  render() {
    const { context: { statsLoading }, answer } = this.props;

    const { data } = this.state;

    return (
      <div className="chart-wrapper">
        <h4 className="mb-2">
          {
            answer === 'yes' ? (
              'How did other people choose to spend the money?'
            ) : (
              <React.Fragment>
                {
                  (!statsLoading && data.chart) && `${_.find(data.text, ['name', "No"]).total}% of people also said 'No'`
                }
              </React.Fragment>
            )
          }
        </h4>
        <div className="row">
          {
            statsLoading || (!data.chart || data.chart.length !== 2) ? (
              <div className="no-chart-data">
                {
                  statsLoading ? ('Loading') : (
                    'No comparison data available just yet, check again in a little while'
                  )
                }
              </div>
            ) : (
                <React.Fragment>
                  <div className="col-lg-6 col-md-6 col-xs-12 chart-value mt-2 mb-2">
                    <table>
                      <tbody>
                        {
                          _.orderBy(data.text, 'total', 'desc').map((item, index) => {
                            return (
                              <tr key={index}>
                                <td className="chart-value-item"><div className="chart-value-color" style={{ backgroundColor: item.color }} />{item.name}:</td>
                                <td className="chart-value-item">{`${item.total}%`}</td>
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                  <div className="col-lg-6 col-md-6 col-xs-12">
                    <Donut
                      data={data.chart}
                      lineWidth={30}
                      animate
                    />
                  </div>
                </React.Fragment>
              )
          }
        </div>
        {
          (!statsLoading && data.chart && data.chart.length >= 2) && (
            <div className="chart-meta">Live stats, updated every 10 mins</div>
          )
        }
      </div>
    );
  }
}

export default withContext(Chart);
